import { createContext } from "react";

const DomainContext = createContext(null);

export default DomainContext;